// const size = {
//   mobileS: "320px",
//   mobileM: "375px",
//   mobileL: "425px",
//   tablet: "768px",
//   laptop: "1280px",
//   laptopL: "1440px",
//   desktop: "1920px",
// }

// export const device = {
//   mobileXS: `(max-width: ${size.mobileS})`,
//   mobileS: `(min-width: ${size.mobileS})`,
//   mobileM: `(min-width: ${size.mobileM})`,
//   mobileL: `(min-width: ${size.mobileL})`,
//   tablet: `(min-width: ${size.tablet})`,
//   laptop: `(min-width: ${size.laptop})`,
//   laptopL: `(min-width: ${size.laptopL})`,
//   desktop: `(min-width: ${size.desktop})`,
// }

const size = {
  mobile: 320,
  tablet: 768,
  desktop: 1920,
}

export const device = {
  mobile: `(max-width: ${size.mobile}px)`,
  tablet: `(min-width: ${size.mobile}px) and (max-width: ${size.tablet}px)`,
  desktop: `(min-width: ${size.tablet + 1}px)`,
}
